import React, { useEffect } from "react";

import MasterSecurityTable from "./MasterSecurityTable";
import MasterSecurityAdd from "./MasterSecurityAdd";
import MasterSecurityEdit from "./MasterSecurityEdit";

import Breadcrumbs from "../../../components/ui/Breadcrumbs";

import useApiNew from "../../../utils/useApiNew";
import axios from "axios";

import DeleteAlert from "../../../components/ui/DeleteAlert";

import { errorNotify, successNotify } from "../../../Services/Notification";
import { actionPermissions } from "../../../components/authNavigation/AuthNavbar";

const securityApiURL = `${process.env.REACT_APP_API_URL}api/security-type`;
const exportSecurityApiURL = `${process.env.REACT_APP_API_URL}api/export-security-type`;

const MasterSecurity = () => {
  const [renderKey, setRenderKey] = React.useState(0);
  const [isAdd, setIsAdd] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [selectedItemId, setSelectedItemId] = React.useState();
  const [globalFilters, setGlobalFilters] = React.useState();
  const [data, setData] = React.useState([]);
  const [isButtonClicked, setIsButtonClicked] = React.useState();
  const [isDownloadClicked, setIsDownloadClicked] = React.useState();

  const triggerRerender = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };

  const name = "security";

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  let { data: bankData, loading } = useApiNew(
    securityApiURL,
    "GET",
    { headers },
    renderKey,
  );

  bankData = bankData?.map((item) => ({
    ...item,
    status: item.status ? "Active" : "Inactive",
  }));

  // GET ONE

  const handleGetOneSecurity = async (id) => {
    const getOneAPI = `${securityApiURL}/${id}`;

    try {
      const res = await axios.get(getOneAPI, { headers });
      const resData = res.data.data;

      triggerRerender();

      if (!resData.error) return resData;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const filterBankData = () => {
    let filterData = bankData;
    if (globalFilters) {
      filterData = bankData.filter(
        (item) =>
          item?.security_type
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.short_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.asset_class
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.credit_debit
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.account_short_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.status?.toLowerCase() === globalFilters?.toLowerCase(),
      );
    }
    setData(filterData);
  };
  useEffect(() => {
    filterBankData();
  }, [globalFilters]);

  // ADD

  const handleAddSecurity = async (data) => {
    setIsButtonClicked(true);
    try {
      const res = await axios.post(securityApiURL, data, { headers });
      const resData = res.data;

      triggerRerender();

      if (!resData.error) {
        successNotify("Data added.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // EDIT

  const handleEditSecurity = async (segmentId, data) => {
    setIsButtonClicked(true);
    const updateAPI = `${securityApiURL}/${segmentId}`;

    try {
      const res = await axios.put(updateAPI, data, { headers });
      const resData = res.data;
      console.log(resData);

      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // DELETE

  const handleDeleteSecurity = async () => {
    const deleteAPI = `${securityApiURL}/${selectedItemId}`;
    try {
      const res = await axios.delete(deleteAPI, { headers });
      const resData = res.data;
      triggerRerender();
      if (!resData.error) {
        successNotify("Data deleted.");
        setIsDelete(false);
        return true;
      } else {
        errorNotify(resData?.message);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      return false;
    }
  };

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10);

  const downloadExcel = async (filename) => {
    try {
      const apiEndpoint = exportSecurityApiURL;
      const headers = {
        Authorization: `Bearer ${
          sessionStorage.getItem("subscriberToken")
            ? sessionStorage.getItem("subscriberToken")
            : sessionStorage.getItem("token")
        }`,
      };
      const response = await axios.get(apiEndpoint, {
        headers,
        responseType: "blob",
      });

      if (response && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename; // Set the filename here

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setIsDownloadClicked(false);
      } else {
        console.error("Invalid response or missing data");
        setIsDownloadClicked(false);
      }
    } catch (error) {
      errorNotify("Something went wrong.");
      setIsDownloadClicked(false);
    }
  };

  const downloadSecurity = () => {
    setIsDownloadClicked(true);
    const filename = `Security-Master_${formattedDate}.xlsx`;
    downloadExcel(filename);
  };

  const breadcrumbs = ["Home", "Master", "Security Type"];

  const buttonConfig = {
    value: "security",
    name: "Security",
    getOneHandler: handleGetOneSecurity,
    addHandler: handleAddSecurity,
    editHandler: handleEditSecurity,
    deleteHandler: handleDeleteSecurity,
    downloadHandler: downloadSecurity,
    closeAddModal: () => setIsAdd(false),
    closeEditModal: () => setIsEdit(false),
  };

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />
      <MasterSecurityTable
        tableData={globalFilters ? data : bankData}
        buttonConfig={buttonConfig}
        setIsAdd={setIsAdd}
        setIsEdit={setIsEdit}
        setIsDelete={setIsDelete}
        setSelectedItemId={setSelectedItemId}
        setGlobalFilters={setGlobalFilters}
        loading={loading}
        actionPermissions={actionPermissions("masters", "Security Type")}
        isDownloadClicked={isDownloadClicked}
      />
      {isAdd && (
        <MasterSecurityAdd
          buttonConfig={buttonConfig}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isEdit && (
        <MasterSecurityEdit
          buttonConfig={buttonConfig}
          selectedItemId={selectedItemId}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isDelete && (
        <DeleteAlert
          closeHandler={() => setIsDelete(false)}
          deleteHandler={buttonConfig.deleteHandler}
        />
      )}
    </div>
  );
};

export default MasterSecurity;
